<template>
	<main>
		<!-- <NavigationCard image="/assets/img/Products/navigation.png" title="PRODUCT CATEGORY" :showOverlay="false" /> -->

		<NavigationCard topUrl="../../../assets/img/TopFirst/ProductTop.mp4" topUrlType="video" />
		<div class="page_content">
			<div class="pt-4 pb-4">
				<section class="container"
					style="background:linear-gradient( 314deg, #000000 0%, #363636 100%);max-width: 1520px;">
					<!-- <div class=" pl-4 pr-4 content_margin"
						style="width: 19.625rem;height: 51.625rem; background: linear-gradient(to bottom right, #FFCD6E, #E29400);">
						<div class="series-container">
							<p class="text-left font-weight-bold">2” Work Light</p>
							<p class="text-left">Flood/Spot</p>
							<img src="/assets/img/Products/series1.png" style="width: 8rem; height: 8.5rem;">
						</div>
						<div class="series-container">
							<p class="text-left font-weight-bold">2” Work Light</p>
							<p class="text-left">Flood/Spot</p>
							<img src="/assets/img/Products/series2.png" style="width: 8rem; height: 8.5rem;">
						</div>
						<div class="series-container">
							<p class="text-left font-weight-bold">2” Work Light</p>
							<p class="text-left">Flood/Spot</p>
							<img src="/assets/img/Products/series3.png" style="width: 8rem; height: 8.5rem;">
						</div>
						<div class="series-container">
							<p class="text-left font-weight-bold">2” Work Light</p>
							<p class="text-left">Flood/Spot</p>
							<img src="/assets/img/Products/series4.png" style="width: 8rem; height: 8.5rem;">
						</div>
					</div> -->
					<el-row style="display: flex;max-height: 720px;">
						<el-col style="width: 220px;background: linear-gradient( 180deg, #FFCD6E 0%, #FFCD6E 100%);">
							<!-- <div class="series-container" style="padding-left: 10px;" >
								<p class="text-left font-weight-bold">2” Work Light</p>
								<p class="text-left">Flood/Spot</p>
								<img src="/assets/img/Products/series1.png" style="width: 8rem; height: 8.5rem;">
							</div> -->
							<div v-for="(item ,index) in leftData" :key="index" class="series-container"
								style="padding-left: 10px;border-bottom:#212121 solid 1px;overflow: hidden;"
								:class="{ active: selectedIndex === index }" @click="selectBox(item,index)">
								<p class="text-left font-weight-bold">{{item.code}}</p>
								<p class="text-left">{{item.inSize}}</p>
								<img :src="item.coverUrl" style="width: 8rem; height: 6.5rem;" loading="lazy" >
							</div>
						</el-col>
						<el-col
							style="flex: 1;background: linear-gradient( 180deg, #363636 0%, #000000 100%);text-align: left; height: auto;"
							class=" p-4 row ">
							<div class="col-md-12" style="min-height: 110px;">
								<div style="display: flex;justify-content: space-between;">
									<div style="display: flex;
										flex-direction: column;">
										<div style="color: #FCB42E;font-size: 40px;" v-if="!isFirst">
											{{currentItem.code}}
										</div>
										<div style="color: #fff;font-size: 20px;" v-if="!isFirst">
											{{currentItem.name}}
										</div>
									</div>
									<div style="text-align:center;" @click="grayImg" v-if="user||$isDevelopment">
										<div>
											<img src="/assets/img/products/favorite-btn.png" style="width:20px;"
												:class="{grayscale:isGrayFavorite}" loading="lazy" >
										</div>
										<div>Favorites</div>
									</div>
								</div>
							</div>

							<div class="col-md-12">
								<div
									style="justify-content: center;align-items: center;max-height: 30.7rem;min-height: 480px;">
									<img :src="topUrl" style="object-fit: contain;max-height: 440px;" loading="lazy" >
								</div>
							</div>
							<div
								style="display: flex; width: 100%; height: auto; justify-content: flex-end; flex-wrap: wrap;">
								<div class="ml-2 grayBorder" v-for="(item,index) in detailImgList" :key="index"
									@click="showImg(item,index)"
									style="display: flex; justify-content: center; align-items: center; height: 6rem; width: 6rem; "
									:class="{ 'activeImgBorder': currentImgIndex === index }">
									<img :src="item.img" loading="lazy" >
								</div>
								<!-- <div class="ml-2"
									style="display: flex; justify-content: center; align-items: center; height: 6rem; width: 6rem; border: 1px solid #FCB42E;">
									<img src="/assets/img/Products/details1.png">
								</div>
								<div class="ml-2"
									style="display: flex; justify-content: center; align-items: center; height: 6rem; width: 6rem; border: 1px solid #FCB42E;">
									<img src="/assets/img/Products/details2.png">
								</div>
								<div class="ml-2"
									style="display: flex; justify-content: center; align-items: center; height: 6rem; width: 6rem; border: 1px solid #FCB42E;">
									<img src="/assets/img/Products/details3.png">
								</div>
								<div class="ml-2"
									style="display: flex; justify-content: center; align-items: center; height: 6rem; width: 6rem; border: 1px solid #FCB42E;">
									<img src="/assets/img/Products/details4.png">
								</div> -->
							</div>
						</el-col>
					</el-row>
					<!-- <div class="col-md-10 p-4 row content_margin"
						style=" flex: 1;background: linear-gradient(to bottom right, #363636,#000000);text-align: left; height: auto; ">
						<div class="col-md-12">
							<div style="display: flex;justify-content: space-between;">
								<div style="display: flex;
									flex-direction: column;">
									<div style="color: #FCB42E;font-size: 40px;">SA6304 SERIES
									</div>
									<div style="color: #fff;font-size: 20px;">
										2”2.5”3.9”4.4”&6”Multi-Function Driving Light
									</div>
								</div>
								<div style="text-align:center;" @click="grayImg">
									<div><img src="/assets/img/products/favorite-btn.png" style="width:20px;" :class="{grayscale:isGrayFavorite}" ></div>
									<div>Favorites</div>
								</div> 
							</div>
						</div>
						
						<div class="col-md-12">
							<div style="justify-content: center;align-items: center;max-height: 42.7rem;">
								<img src="/assets/img/Products/product_series1.png"
									style="object-fit: contain;max-height: 36.7rem;">
							</div>
						</div>
						<div
							style="display: flex; width: 100%; height: auto; justify-content: flex-end; flex-wrap: wrap;">
							<div class="ml-2"
								style="display: flex; justify-content: center; align-items: center; height: 6rem; width: 6rem; border: 1px solid #FCB42E;">
								<img src="/assets/img/Products/details1.png">
							</div>
							<div class="ml-2"
								style="display: flex; justify-content: center; align-items: center; height: 6rem; width: 6rem; border: 1px solid #FCB42E;">
								<img src="/assets/img/Products/details2.png">
							</div>
							<div class="ml-2"
								style="display: flex; justify-content: center; align-items: center; height: 6rem; width: 6rem; border: 1px solid #FCB42E;">
								<img src="/assets/img/Products/details3.png">
							</div>
							<div class="ml-2"
								style="display: flex; justify-content: center; align-items: center; height: 6rem; width: 6rem; border: 1px solid #FCB42E;">
								<img src="/assets/img/Products/details4.png">
							</div>
						</div>


					</div> -->
				</section>
				<!-- <div style="width:100%;background: linear-gradient( 180deg, #292929 0%, #000000 100%);">
					<section class="container" style="text-align: left;">

						<div class="row tab mb-4" style="margin-top:3rem">
							<div class="col-md-4 pt-1" @click="openTab('Specifications')">
								<p class="col h5">Product Speecifications</p>
								<p class=" btn custom-btn-primary" v-if="activeCity == 'Specifications'"
									style="margin-bottom: -1.1rem;    padding: 0.12rem 6rem;">
								</p>
							</div>
							<div class="col-md-4 pt-1" @click="openTab('PartNumberList')">
								<p class="col h6">Part Number List</p>
								<p class="btn custom-btn-primary" v-if="activeCity == 'PartNumberList'"
									style="margin-bottom: -1.1rem;    padding: 0.12rem 6rem;">
								</p>
							</div>
							<div class="col-md-4 pt-1" @click="openTab('Certificate')">
								<p class="col h6">Certificate</p>
								<p class="btn custom-btn-primary" v-if="activeCity == 'Certificate'"
									style="margin-bottom: -1.1rem;    padding: 0.12rem 6rem;">
								</p>
							</div>
						</div>
						<div class="mb-4" style="line-height: 1.2;">
							<div id="Specifications" class="tabcontent row" v-show="activeCity == 'Specifications'">
								<table class="table col-md-5-1 content_margin">
									<tbody>
										<tr>
											<th width="40%" scope="row">Depth（mm）</th>
											<td> 69 </td>
										</tr>
										<tr>
											<th scope="row">Height（mm）</th>
											<td> 120 </td>
										</tr>
										<tr>
											<th scope="row"> Length（mm） </th>
											<td> 158 </td>
										</tr>
										<tr>
											<th scope="row"> Weight（lbs.） </th>
											<td> 12.01 </td>
										</tr>
										<tr>
											<th scope="row"> LED Power </th>
											<td> 4PCS 3W LED </td>
										</tr>
										<tr>
											<th scope="row"> Voltage </th>
											<td> DC 10-33V </td>
										</tr>
									</tbody>
								</table>
								<table class="table col-md-5-1 content_margin">
									<tbody>
										<tr>
											<th width="40%" scope="row"> LED Power </th>
											<td> 4PCS 3W LED </td>
										</tr>
										<tr>
											<th scope="row"> Voltage </th>
											<td> DC 10-33V </td>

										</tr>
										<tr>
											<th scope="row"> Max Power </th>
											<td> 12W </td>
										</tr>
										<tr>
											<th scope="row"> Beam </th>
											<td> Flood / Spot </td>
										</tr>
										<tr>
											<th scope="row"> Lumes </th>
											<td> 3150LM </td>
										</tr>
									</tbody>
								</table>
							</div>
							<div id="PartNumberList" class="tabcontent" v-show="activeCity == 'PartNumberList'">
								<table class="table">
									<thead class="thead-dark">
										<tr>
											<th scope="col">
												Part Number
											</th>
											<th scope="col">
												Description
											</th>
											<th scope="col">
												Spec Sheet
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												SM6064-45-01
											</td>
											<td>
												45W Rectangle Diamond Series LED Work Light Leaflet
											</td>
											<td>
												Download
											</td>
										</tr>
										<tr>
											<td>
												SM6064-45-02
											</td>
											<td>
												45W Rectangle Diamond Series LED Work Light Instructions
											</td>
											<td>
												Download
											</td>
										</tr>
										<tr>
											<td>
												SM6064-45-03
											</td>
											<td>
												45W Rectangle Diamond Series LED Work Light Specification
											</td>
											<td>
												Download
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div id="Certificate" class="tabcontent" v-show="activeCity == 'Certificate'">
								<table class="table">
									<thead class="thead-dark">
										<tr>
											<th scope="col">
												Certificate
											</th>
											<th scope="col">
												Description
											</th>
											<th scope="col">
												Spec Sheet
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												ECE R10
											</td>
											<td>
												Electromagnetic Compatibility,EMC
											</td>
											<td>
												Download
											</td>
										</tr>
										<tr>
											<td>
												ECE R148(R7)
											</td>
											<td>
												Lighting and Light-Signalling Devices
											</td>
											<td>
												<div style="display:flex;align-item:centers;">
													<img src="/assets/img/Main/路径 3408@2x.png"
														style=" max-width: 20px;max-height:20px;">
													<p style="margin-left:5px;">Download</p>
												</div>
											</td>
										</tr>

									</tbody>
								</table>
							</div>
						</div>
						<div style="height:15%;"> <label for=""></label></div>
					</section>
				</div> -->
				<!-- 表格————规格 -->
				<section class="container"
					style="text-align: left;background: linear-gradient( 180deg, #292929 0%, #000000 100%);max-width: 1520px;">

					<div class="row tab mb-4" style="margin-top:3rem">
						<div class="col-md-4 pt-1" @click="openTab('Specifications')">
							<p class="col h5" >Product Speecifications</p>
							<p class=" btn custom-btn-primary" v-if="activeCity == 'Specifications'"
								style="margin-bottom: -1.0rem;    padding: 0.05rem 5rem;">
							</p>
						</div>
						<div class="col-md-4 pt-1" @click="openTab('PartNumberList')">
							<p class="col h6">Part Number List</p>
							<p class="btn custom-btn-primary" v-if="activeCity == 'PartNumberList'"
								style="margin-bottom: -1.0rem;    padding: 0.05rem 5rem;">
							</p>
						</div>
						<div class="col-md-4 pt-1" @click="openTab('Certificate')">
							<p class="col h6">Certificate</p>
							<p class="btn custom-btn-primary" v-if="activeCity == 'Certificate'"
								style="margin-bottom: -1.0rem;    padding: 0.05rem 5rem;">
							</p>
						</div>
					</div>
					<div class="mb-4" style="line-height: 1.2;">
						<div id="Specifications" class="tabcontent row" v-show="activeCity == 'Specifications'">
							<table class="table col-md-5-1 content_margin">
								<tbody>
									<tr>
										<th scope="row"> Length（mm） </th>
										<td> {{currentItem.length}} </td>
									</tr>
									<tr>
										<th width="40%" scope="row">Depth（mm）</th>
										<td> {{currentItem.depth}} </td>
									</tr>
									<tr>
										<th scope="row">Height（mm）</th>
										<td> {{currentItem.height}} </td>
									</tr>


									<tr>
										<th scope="row"> LEDs </th>
										<td> {{currentItem.ledPower}} </td>
									</tr>
									<tr>
										<th scope="row"> Voltage </th>
										<td> {{currentItem.voltage}} </td>
									</tr>
									<tr>
										<th scope="row"> LED Color </th>
										<td> {{currentItem.weight}} </td>
									</tr>
								</tbody>
							</table>
							<table class="table col-md-5-1 content_margin">
								<tbody>
									<tr>
										<th width="40%" scope="row"> Max Power </th>
										<td> {{currentItem.maxPower}} </td>
									</tr>
									<tr>
										<th scope="row"> Beam </th>
										<td> {{currentItem.beam}} </td>

									</tr>
									<tr>
										<th scope="row"> Lumes </th>
										<td> {{currentItem.lumes}} </td>
									</tr>
									<tr>
										<th scope="row"> Flash Pattern/Function </th>
										<td> {{currentItem.function}} </td>
									</tr>
									<tr>
										<th scope="row"> Certification </th>
										<td> {{currentItem.certification}} </td>
									</tr>
									<tr>
										<th scope="row"> IP Rating </th>
										<td> {{currentItem.ipRating}} </td>
									</tr>
								</tbody>
							</table>
						</div>
						<div id="PartNumberList" class="tabcontent" v-show="activeCity == 'PartNumberList'">
							<table class="table">
								<thead class="thead-dark">
									<tr>
										<th scope="col">
											Part Number
										</th>
										<th scope="col">
											Description
										</th>
										<th scope="col">
											Spec Sheet
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item,index) in bookList" :key="index">
										<td>{{item.name}}</td>
										<td>
											<div v-html="item.description"></div>
										</td>
										<td>
											<span @click="cellClick(item.url)"
												style="padding-left: 20px;color: #4990e2; text-decoration: underline;">
												{{item.itemNum}}
											</span>

										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div id="Certificate" class="tabcontent" v-show="activeCity == 'Certificate'">
							<table class="table">
								<thead class="thead-dark">
									<tr>
										<th scope="col">
											Certificate
										</th>
										<th scope="col">
											Description
										</th>
										<th scope="col">
											Spec Sheet
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in certData" :key="item.id" class="text-muted highlight"
										style="height: 1;color: #606266;">

										<td style="text-align: left;padding-left: 10px;">{{item.typeName}}</td>
										<td style="text-align: left;padding-left: 10px;">{{item.name}}</td>
										<td>
											<a href="#" style="color: #4990e2; text-decoration: underline;"
												target="_blank"
												@click.prevent="downLoadCert(item.certID,item.itemNum)">{{item.itemNum}}</a>
										</td>

									</tr>

								</tbody>
							</table>
						</div>
					</div>
					<div style="height:15%;"> <label for=""></label></div>
				</section>
				<!-- 关联产品 -->
				<section class="container" style="margin-top:40px;max-width: 1520px;">
					<div class="row" style="padding-left: 15px;margin-bottom:1rem">
						<div class="mr-2" style="background-color: #FCB42E;height: 16px;    width: 3px;margin-top:6px;">
						</div>
						<h6 class="h4 mb-2 font-weight-five">
							Related Products
						</h6>
					</div>

					<div class="row">
						<div class="col-md-2-0  " style="padding-left:5px;padding-right:5px;"
							v-for="(item,index) in unionProduct" :key="index" @click="navigateTo(item)">
							<div class="card shadow-sm card-border">
								<img class="card-img-top" :src="item.coverUrl" alt="Card image cap">
								<div class="card-body card-body-list">
									<h6 class="card-title mb-1" style="color: #FCB42E;font-size:15px;">{{item.code}}
									</h6>
									<p class="card-title card-sub-title mb-1" style="font-size:13px;">
										{{item.name}}
									</p>
									<p class="card-text text-muted multiline" style="font-size:13px;"
										v-html="item.remark">
										<!-- {{item.remark}} -->
									</p>
								</div>
							</div>
						</div>
						<!-- <div class="col-md-2-0  " style="padding-left:5px;padding-right:5px;" @click="navigateTo()">
							<div class="card shadow-sm card-border">
								<img class="card-img-top" src="/assets/img/Products/product1.png" alt="Card image cap">
								<div class="card-body card-body-list">
									<h6 class="card-title mb-1" style="color: #FCB42E;font-size:15px;">SA6051</h6>
									<p class="card-title card-sub-title mb-1" style="font-size:13px;">
										Work Light,position light（red/amber/white）
									</p>
									<p class="card-text text-muted multiline" style="font-size:13px;">
										Engineered with precision optics and advanced LED or HID technology, our
										lights
										provide superior brightness, optimal beam patterns. Whether you’re
										navigating
										urban
										streets or off-road adventures, our lights are engineered to perform and
										built
										to
										last.
									</p>
								</div>
							</div>
						</div>
						<div class="col-md-2-0  " style="padding-left:5px;padding-right:5px;" @click="navigateTo()">
							<div class="card shadow-sm card-border">
								<img class="card-img-top" src="/assets/img/Products/product2.png" alt="Card image cap">
								<div class="card-body card-body-list">
									<h6 class="card-title mb-1" style="color: #FCB42E;font-size:15px;">SA6053</h6>
									<p class="card-title card-sub-title mb-1" style="font-size:13px;">
										Work Light,position light（red/amber/white）
									</p>
									<p class="card-text text-muted multiline" style="font-size:13px;">
										Engineered with precision optics and advanced LED or HID technology, our
										lights
										provide superior brightness, optimal beam patterns. Whether you’re
										navigating
										urban
										streets or off-road adventures, our lights are engineered to perform and
										built
										to
										last.
									</p>
								</div>
							</div>
						</div>
						<div class="col-md-2-0  " style="padding-left:5px;padding-right:5px;" @click="navigateTo()">
							<div class="card shadow-sm card-border">
								<img class="card-img-top" src="/assets/img/Products/product3.png" alt="Card image cap">
								<div class="card-body card-body-list">
									<h6 class="card-title mb-1" style="color: #FCB42E;font-size:15px;">SA6053</h6>
									<p class="card-title card-sub-title mb-1" style="font-size:13px;">
										Work Light,position light（red/amber/white）
									</p>
									<p class="card-text text-muted multiline" style="font-size:13px;">
										Engineered with precision optics and advanced LED or HID technology, our
										lights
										provide superior brightness, optimal beam patterns. Whether you’re
										navigating
										urban
										streets or off-road adventures, our lights are engineered to perform and
										built
										to
										last.
									</p>
								</div>
							</div>
						</div>
						<div class="col-md-2-0  " style="padding-left:5px;padding-right:5px;" @click="navigateTo()">
							<div class="card shadow-sm card-border">
								<img class="card-img-top" src="/assets/img/Products/product3.png" alt="Card image cap">
								<div class="card-body card-body-list">
									<h6 class="card-title mb-1" style="color: #FCB42E;font-size:15px;">SA6053</h6>
									<p class="card-title card-sub-title mb-1" style="font-size:13px;">
										Work Light,position light（red/amber/white）
									</p>
									<p class="card-text text-muted multiline" style="font-size:13px;">
										Engineered with precision optics and advanced LED or HID technology, our
										lights
										provide superior brightness, optimal beam patterns. Whether you’re
										navigating
										urban
										streets or off-road adventures, our lights are engineered to perform and
										built
										to
										last.
									</p>
								</div>
							</div>
						</div>
						<div class="col-md-2-0  " style="padding-left:5px;padding-right:5px;" @click="navigateTo()">
							<div class="card shadow-sm card-border">
								<img class="card-img-top" src="/assets/img/Products/product3.png" alt="Card image cap">
								<div class="card-body card-body-list">
									<h6 class="card-title mb-1" style="color: #FCB42E;font-size:15px;">SA6053</h6>
									<p class="card-title card-sub-title mb-1" style="font-size:13px;">
										Work Light,position light（red/amber/white）
									</p>
									<p class="card-text text-muted multiline" style="font-size:13px;">
										Engineered with precision optics and advanced LED or HID technology, our
										lights
										provide superior brightness, optimal beam patterns. Whether you’re
										navigating
										urban
										streets or off-road adventures, our lights are engineered to perform and
										built
										to
										last.
									</p>
								</div>
							</div>
						</div> -->
					</div>
				</section>
			</div>
		</div>
	</main>
</template>

<script>
	import NavigationCard from '@/components/common/TopVideo.vue';
	import { getProductDetailLeft, getProductDetailImg, addFavorite, getFavoriteList, delFavoriteInfo, getUnionProduct } from "@/api/rbac/product";

	import { getBookProNum } from "@/api/rbac/bookHand";
	import { getCertRight, getCertPdf } from "@/api/rbac/certificate";//, getPartImg, getCertPdf
	// import RouteNav from '@/components/common/RouteNav.vue';
	export default {
		name: 'ProductDetails',
		components: {
			NavigationCard,
			// RouteNav
		},
		created() {
			this.getLeftData();
		},
		data() {
			return {
				activeCity: 'Specifications',
				images: [
					// require('../../assets/img/demo/blog3.jpg'),
					// require('../../assets/img/demo/blog4.jpg'),
					// require('../../assets/img/demo/blog5.jpg'),
					// require('../../assets/img/demo/blog6.jpg'),
					// require('../../assets/img/demo/blog7.jpg'),
					// require('../../assets/img/demo/blog8.jpg'),
					// require('../../assets/img/demo/blog9.jpg'),
				], // 所有图片的路径
				currentImage: require('../../assets/img/demo/blog3.jpg'), // 当前显示的主图片
				startIndex: 0, // 可见图片列表的起始索引
				visibleCount: 4, // 可见缩略图数量
				isGrayFavorite: true,
				leftData: [
					// { code: 'SA6303 SERIES', inSize: '3” Work Light', url: '../../../assets/img/Products/series3.png' },
					// { code: 'SA6302 SERIES', inSize: '2” Work Light', url: '../../../assets/img/Products/series2.png' },
					// { code: 'SA6301 SERIES', inSize: '1” Work Light', url: '../../../assets/img/Products/series1.png' },
				],
				selectedIndex: null, // 用于跟踪当前选中的 box 索引
				topUrl: '',
				currentItem: {},
				detailImgList: [],
				isFirst: true,
				favoriteID: 0,
				unionProduct: [],//关联产品
				currentImgIndex: null,
				bookList: [],
				certData: [],
				downloadList: [],
			};
		},
		computed: {
			user() {
				if (this.$store.state.user == null) {
					var storUser = localStorage.getItem("token")
					if (storUser == null) {
						return this.$store.state.user
					}
					else {
						const storedUser = localStorage.getItem("token");

						var thisuser = JSON.parse(storedUser);
						return thisuser
						// if (thisuser.name.toString() == 'admin') {
						// 	return thisuser;
						// }
						// else {
						// 	return this.$store.state.user
						// }
					}

				}
				else {
					return this.$store.state.user
				}
				// 使用计算属性来获取用户信息，这样当用户信息变化时，界面也会自动更新
			},
			getID() {
				return this.$route.params.category || 'No Category'; // 提供默认值
			},
			getTypeID() {
				return this.$route.params.productsName || 'No Category'; // 提供默认值
			},
			visibleImages() {
				// 获取当前可见范围内的图片
				return this.images.slice(
					this.startIndex,
					this.startIndex + this.visibleCount
				);
			},
		},
		methods: {
			selectImage(image) {
				this.currentImage = image; // 切换主图片
			},
			scrollUp() {
				if (this.startIndex > 0) {
					this.startIndex--; // 上滚
				}
			},
			scrollDown() {
				if (this.startIndex < this.images.length - this.visibleCount) {
					this.startIndex++; // 下滚
				}
			},
			openTab(cityName) {
				this.activeCity = cityName;
				if (cityName == "Certificate") {
					this.getCertRight(this.currentItem.id);
				}
			},
			grayImg() {
				if (!this.isFirst) {
					if (this.isGrayFavorite) {
						//添加
						const formData = new FormData();
						formData.append("productID", this.currentItem.id)
						formData.append("ID", this.favoriteID)
						formData.append("personID", this.user == null ? 1 : this.user.id)
						addFavorite(formData).then(res => {
							this.favoriteID = res.data;
							if (res.data <= 0) {
								return alert("Fail Add Favorite")
							}
						})
					}
					else {
						//删除
						delFavoriteInfo(this.favoriteID).then(res => {
							if (res.data != "ok") {
								return alert("Fail Delete")
							}
							else {
								this.favoriteID = 0;
							}
						})
					}
					this.isGrayFavorite = !this.isGrayFavorite;
				}
			},

			getLeftData() {
				var strWhere = ''
				if (this.user == null) {
					strWhere = ' and DATEDIFF(mm,happendate,getDate())>=(select MAX(intMonth) from WebUserLevelSet)'
				}
				else {
					// if (this.user.isCus == 1) {
					// 	strWhere = ` and DATEDIFF(mm,happenDate,GETDATE())>=${this.user.intMonth}`
					// }
					strWhere = ` and DATEDIFF(mm,happenDate,GETDATE())>=${this.user.intMonth}`
				}
				getProductDetailLeft({ id: this.$route.params.category, mainCodeID: this.$route.params.productsName, strWhere: strWhere }).then(res => {
					if (res.data.length == 0) {
						// console.log(this.treeData)
						this.topUrl = '';
						this.currentItem = {};
					}
					else {
						this.leftData = res.data;
						this.leftData.forEach(element => {
							element.coverUrl = '../../../assets/img/ProductCover/' + element.coverUrl
						});
						this.currentItem = { ...this.leftData[0] }
						this.getImgList(this.currentItem.id)
						this.topUrl = '../../../assets/img/MainCode/' + this.leftData[0].mainCodeUrl
						if (this.currentItem.tubeUrl) {
							var ybImg = { id: 0, img: '../../../assets/img/Main/youTubeLink.png' }
							this.detailImgList.push(ybImg);
						}
						this.getBookProNum(this.currentItem.id)
					}
				})
				this.getUnionProduct(this.$route.params.category)
			},
			getImgList(id) {
				// this.topUrl = ''
				getProductDetailImg({ id: id }).then(resp => {
					if (resp.data.length == 0) {
						this.detailImgList = [];
						this.topUrl = '';
					}
					else {
						// resp.data.forEach(item => {
						// 	item.img = '../../../assets/img/products/' + item.img
						// 	this.detailImgList.push(item);
						// })
						this.detailImgList = resp.data
						this.detailImgList.forEach(item => {
							item.img = '../../../assets/img/products/' + item.img
						})
						if (!this.isFirst) {
							this.topUrl = this.detailImgList[0].img
						}
					}
					if (this.currentItem.tubeUrl) {
						this.checkLinkType()

					}


				})
			},
			getFavoriteList() {
				if (this.user) {
					getFavoriteList({ strWhere: ` and productID=${this.currentItem.id} and personID=${this.user.id}` }).then(res => {
						{
							this.isGrayFavorite = true
							if (res.data.length == 0) {
								this.isGrayFavorite = true;
								this.favoriteID = 0;
							}
							else {
								this.isGrayFavorite = false;
								this.favoriteID = res.data[0].id
							}
						}
					})
				}

			},
			selectBox(item, index) {
				this.detailImgList = []
				this.selectedIndex = index; // 更新选中的 box 索引
				this.currentItem = { ...item }
				this.getImgList(this.currentItem.id)
				this.getFavoriteList()
				this.getBookProNum(this.currentItem.id)
				this.isFirst = false
			},
			getBookProNum(id) {
				getBookProNum({ strWhere: ' and a.productID=' + id }).then(res => {
					this.bookList = res.data;
				})
			},
			cellClick(name) {
				// 获取协议
				const protocol = window.location.protocol;
				// 获取主机名
				const hostname = window.location.hostname;
				// 获取端口号
				const port = window.location.port;
				const httpUrl = protocol + '//' + hostname + ':' + port + '/assets/img/handbook/' + name
				const a = document.createElement('a');
				a.href = httpUrl;
				a.download = name;
				a.click();
				// window.open(httpUrl)
			},
			showImg(item, index) {

				this.currentImgIndex = index
				this.isFirst = false
				if (item.id != 0) {
					this.topUrl = item.img
				}
				else {
					const url = this.currentItem.tubeUrl; // 替换为你要打开的 URL
					window.open(url, '_blank');
				}
			},
			getUnionProduct(id) {
				var strWhere = ''
				if (this.user == null) {
					strWhere = ' and DATEDIFF(mm,happendate,getDate())>=(select MAX(intMonth) from WebUserLevelSet)'
				}
				else {
					// if (this.user.isCus == 1) {
					// 	strWhere = ` and DATEDIFF(mm,happenDate,GETDATE())>=${this.user.intMonth}`
					// }
					strWhere = ` and DATEDIFF(mm,happenDate,GETDATE())>=${this.user.intMonth}`
				}
				getUnionProduct({ id: id, strWhere: strWhere }).then(res => {
					this.unionProduct = res.data;
					this.unionProduct.forEach(item => {
						item.coverUrl = '../../../assets/img/ProductCover/' + item.coverUrl
					})
				})
			},
			navigateTo(item) {
				this.$router.push({ name: 'product', params: { category: item.id, productsName: item.mainCodeID } })
			},
			checkLinkType() {
				// 定义facebook链接的正则表达式
				// const facebookRegex = /^https?:\/\/(?:[a-zA-Z0-9.-]+\.)?facebook\.com\/?[\w.-]+\/?(?:\?[^\s]*)?(?:#[^\s]*)?$/;
				const facebookRegex = /^(https?:\/\/)?(www\.)?(facebook\.com|fb\.com)\//;
				// 测试输入的链接
				var isLink = facebookRegex.test(this.currentItem.tubeUrl);
				var ybImg = {};
				if (isLink) {
					//facebook链接
					ybImg = { id: 0, img: '../../../assets/img/Main/faceBookLink.png' }
					this.detailImgList.push(ybImg);
				}
				else {
					// 定义 YouTube 链接的正则表达式
					// const youtubeRegex =/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})(?:\S+)?$/;
					const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//;
					isLink = youtubeRegex.test(this.currentItem.tubeUrl);//youtube链接
					if (isLink) {
						ybImg = { id: 0, img: '../../../assets/img/Main/youTubeLink.png' }
						this.detailImgList.push(ybImg);
					}
					else {
						ybImg = { id: 0, img: '../../../assets/img/Main/otherLink.png' }
						this.detailImgList.push(ybImg);
					}
				}
			},
			getCertRight(id) {
				var strWhere = ' and a.productID=' + id
				getCertRight({ strWhere: strWhere, tableType: 1 }).then(res => {
					this.certData = res.data
					console.log(this.certData)
				})
			},
			downLoadCert(id, itemNum) {
				if (itemNum > 0) {
					//根据ID获取文件地址
					try {
						getCertPdf({ id: id }).then(res => {
							this.downloadList = res.data
							if (res.data.length == 1) {
								// const fileUrl = res.data[0].url; // 文件的URL地址
								const filename = res.data[0].name; // 文件的名

								// 获取完整的URL
								// const fullUrl = window.location.href;
								// 获取协议
								const protocol = window.location.protocol;
								// 获取主机名
								const hostname = window.location.hostname;
								// 获取端口号
								const port = window.location.port;
								const httpUrl = protocol + '//' + hostname + ':' + port + '/assets/img/Certificate/' + filename
								const a = document.createElement('a');
								a.href = httpUrl;
								a.download = filename;
								a.click();
							}
							if (res.data.length > 1) {
								this.pdfVisible = true;
							}
						})
					} catch (error) {
						console.error('获取失败:', error);
					}
				}
			},

		},
	};
</script>

<style scoped>
	@import '../../assets/css/main.css';


	.grayscale {
		filter: grayscale(100%);
		/* 将图片完全转换为灰度 */
	}

	:deep(img) {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	:deep(.series-container) {
		height: 180px;
		;
		padding-top: 1rem;
		color: black;
	}

	:deep(.series-container:not(:last-child)) {
		border-bottom: 1px solid #8F7B54;
	}

	:deep(.tab) {
		border-bottom: 1px solid #ddd;
	}

	:deep(.tabcontent) {
		text-align: left;
		-webkit-animation: fadeEffect 1s;
		animation: fadeEffect 1s;
	}

	:deep(#Specifications table tr) {
		display: flex;
	}

	:deep(#Specifications td) {
		border: 1px solid #3a3f44;
		flex: 1;
	}

	:deep(#Specifications th) {
		border: 1px solid #3a3f44;
		flex: 1;
	}

	:deep(#Specifications .table tr:first-child th) {
		border-top: none;
	}

	:deep(#Specifications .table tr:first-child td) {
		border-top: none;
	}

	:deep(#Specifications .table tr:last-child th) {
		border-bottom: none;
	}

	:deep(#Specifications .table tr:last-child td) {
		border-bottom: none;
	}

	:deep(#Specifications .table th) {
		border-left: none;
		font-size: 14px;
		font-weight: normal;
	}

	:deep(#Specifications .table td) {
		border-right: none;
	}

	/* PartNumberList */
	:deep(#PartNumberList table) {
		border: 1px solid #717171;
		border-collapse: collapse;
	}

	:deep(#PartNumberList table th) {
		background: linear-gradient(to bottom, #212121, #383838);
	}

	:deep(#PartNumberList td) {
		border: none;
	}

	:deep(#PartNumberList th) {
		border: none;
	}

	/* Certificate */
	:deep(#Certificate table) {
		border: 1px solid #717171;
		border-collapse: collapse;
	}

	:deep(#Certificate table th) {
		background: linear-gradient(to bottom, #212121, #383838);
	}

	:deep(#Certificate th) {
		border: none;
	}

	:deep(#Certificate td) {
		border: none;
	}

	/* Fade in tabs */
	@-webkit-keyframes fadeEffect {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	@keyframes fadeEffect {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	:deep(.card-title) {
		font-weight: 600;
		margin-bottom: 0rem;
	}

	:deep(.card-sub-title) {
		color: #fff;
		height: 1.5rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	:deep(.card-border) {
		border: 1px solid #474746;
	}

	:deep(.card-img-top) {
		min-height: 15rem;
		/* object-fit: cover; */
		max-height: 15rem;
		background: linear-gradient(to bottom right, #2C2C2C, #000000);
	}

	:deep(.card-body-list) {
		text-align: left;
		height: 12.3rem;
		background-color: #000000;
		border-bottom-left-radius: calc(0.25rem - 1px);
		border-bottom-right-radius: calc(0.25rem - 1px);
	}

	:deep(.multiline) {
		color: #5F5F5F !important;
		overflow: hidden;
		font-size: 15px;
		display: -webkit-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
	}

	:deep(.photo-group) {
		display: flex;
		height: auto;
		justify-content: center;
		flex-wrap: wrap;
	}

	:deep(.photo-container) {
		text-align: center;
		position: relative;
		width: 15rem;
		height: 15rem;
		cursor: pointer;
		display: flex;
		justify-content: center;
	}

	@media (max-width: 576px) {
		:deep(.photo-container) {}
	}

	@media (max-width: 1200px) {
		:deep(.photo-container:not(:last-child)::after) {
			width: 0px;
		}
	}

	:deep(.photo-container img) {
		position: absolute;
		top: 0;
		width: 80%;
		height: 80%;
		object-fit: contain;
		transition: opacity 1s ease;
	}

	:deep(.photo-title) {
		color: #fff;
		margin-top: 13rem;
		font-size: 14px;
	}

	:deep(.photo-title.active) {
		color: #FCB42E;
	}

	table a {
		text-decoration: underline;
		color: green;
	}

	table td {
		padding-top: 10px;
		font-size: 14px;
		font-family: Avenir, Helvetica, Arial, sans-serif;
	}

	div .active {
		background-color: #E39503;
	}

	.grayBorder {
		border: 1px solid gray;
	}

	div .activeImgBorder {
		border: 2px solid #E39503;
		box-sizing: border-box;
		/* 避免布局偏移 */
	}

	.tab div:hover {
		color: black;
		background-color: #FCB42E;
	}
	.col {
		margin-top: 1rem;
		padding-left: 1rem;
	}
</style>